export default __webpack_public_path__ + "static/media/home__contact.79fcd8ab.jpg";